import React from 'react';

type TableStateElementProps = {
  className?: string;
  children?: React.ReactNode;
};

const SKELETON_ROWS = 6;
const SKELETON_COLUMNS = [
  'is-compact',
  'is-primary',
  'is-wide',
  'is-secondary',
  'is-actions',
];

const appendClassName = (current: string | undefined, addition: string) => {
  if (current && current.includes(addition)) {
    return current;
  }
  if (current) {
    return `${current} ${addition}`;
  }
  return addition;
};

/**
 * Render a shimmering skeleton loader that matches the table layout.
 * @param loadingElement
 */
export const renderTableLoading = (loadingElement: React.ReactNode) => {
  if (!React.isValidElement<TableStateElementProps>(loadingElement)) {
    return loadingElement;
  }

  const className = appendClassName(
    loadingElement.props.className,
    'table-skeleton-wrapper'
  );

  return React.cloneElement(loadingElement, {
    className,
    children: (
      <>
        <div className="sr-only">{loadingElement.props.children}</div>
        <div className="table-skeleton" role="status" aria-live="polite">
          {Array.from({ length: SKELETON_ROWS }).map((_, rowIndex) => (
            <div className="table-skeleton-row" key={rowIndex}>
              {SKELETON_COLUMNS.map((column, columnIndex) => (
                <span
                  key={`${rowIndex}-${columnIndex}`}
                  className={`skeleton-cell ${column}`}
                />
              ))}
            </div>
          ))}
        </div>
      </>
    ),
  });
};

/**
 * Render a friendly empty state when no rows are available.
 * @param info
 */
export const renderTableEmpty = (info: React.ReactNode) => {
  if (!React.isValidElement<TableStateElementProps>(info)) {
    return info;
  }

  const className = appendClassName(info.props.className, 'table-empty-state');

  return React.cloneElement(info, {
    className,
    children: (
      <div className="table-empty-state__content">
        <div className="table-empty-icon" aria-hidden="true">
          <div className="table-empty-icon__dot" />
        </div>
        <div className="table-empty-text">
          <div className="table-empty-title">Дані відсутні</div>
          <div className="table-empty-subtitle">
            Змініть фільтри або створіть новий запис.
          </div>
        </div>
      </div>
    ),
  });
};
